import {
  Button,
  Divider,
  FormControlSizes,
  HStack,
  IconName,
  MixpanelEvent,
  MixpanelEventProperty,
  Toggle,
  useCurrentWindow,
  useMixpanel,
} from '@talos/kyoko';
import { useNavigate } from 'react-router-dom';
import { AdminPaths } from '../NavigationSidebar/hooks/getNavPath';
import { useMarketSelectorContext } from './MarketSelectorContext';
import { MarketSelectorSettingsButton } from './MarketSelectorSettingsButton';
import { MARKET_SELECTOR_POPOUT_WINDOW_NAME } from './tokens';

export function MarketSelectorPanelHeaderSuffix() {
  const mixpanel = useMixpanel();
  const navigate = useNavigate();
  const { showAdvancedMode, advancedMode, setAdvancedMode, isNarrow, disableAggregations } = useMarketSelectorContext();
  const currentWindow = useCurrentWindow();
  const isPopout = currentWindow.name === MARKET_SELECTOR_POPOUT_WINDOW_NAME;

  return (
    <HStack gap="spacing8">
      {showAdvancedMode && (!isNarrow || isPopout) && (
        <>
          <Toggle
            size={FormControlSizes.Small}
            checked={advancedMode}
            onChange={checked => {
              setAdvancedMode(checked);
              if (isPopout && !checked) {
                currentWindow.close();
              }
              mixpanel.track(MixpanelEvent.ToggleAdvancedMode, { [MixpanelEventProperty.Enabled]: checked });
            }}
            label="Advanced Mode"
            data-testid="market-selector-advanced-mode-toggle"
          />
          <Divider orientation="vertical" color="gray.070" />
        </>
      )}
      <HStack gap="spacing4">
        {(!isNarrow || isPopout) && !disableAggregations && (
          <Button
            startIcon={IconName.Exit}
            size={FormControlSizes.Small}
            onClick={() => navigate(AdminPaths.TradingAggregations())}
          >
            Manage
          </Button>
        )}
        <MarketSelectorSettingsButton />
      </HStack>
    </HStack>
  );
}
